import { StrictMode } from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import "@fontsource/figtree/400.css";
import "@fontsource/figtree/500.css";
import "@fontsource/figtree/600.css";
import "@fontsource/figtree/700.css";
import "@fontsource/figtree/900.css";
import "@fontsource/ibm-plex-mono/300.css";
import "@fontsource/ibm-plex-mono/500.css";
import "@fontsource/ibm-plex-mono/700.css";
import "@fontsource/grape-nuts/400.css";
import "@/shared/styles/globals.css";
import { App } from "./App";

const root = document.getElementById("root");
if (!root) throw new Error("Elemento root nao encontrado");

document.documentElement.classList.add("js-ready");

const app = (
  <StrictMode>
    <App />
  </StrictMode>
);

// o index.html do Vite dev serve #root vazio; so o SSR entrega markup pra hidratar
if (root.firstChild) {
  hydrateRoot(root, app);
} else {
  createRoot(root).render(app);
}
